import { render, staticRenderFns } from "./anunt-1.vue?vue&type=template&id=7f5cfd2f&scoped=true"
import script from "./anunt-1.vue?vue&type=script&lang=js"
export * from "./anunt-1.vue?vue&type=script&lang=js"
import style0 from "./anunt-1.vue?vue&type=style&index=0&id=7f5cfd2f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f5cfd2f",
  null
  
)

export default component.exports